// extracted by mini-css-extract-plugin
export var hasHeaderContent = "Modal-module--hasHeaderContent--0c557";
export var modalActions = "Modal-module--modalActions--15e42";
export var modalBody = "Modal-module--modalBody--4136d";
export var modalContentWrapper = "Modal-module--modalContentWrapper--6a5b7";
export var modalHeaderContent = "Modal-module--modalHeaderContent--f8fa5";
export var modalTitle = "Modal-module--modalTitle--24fb4";
export var modalcontent = "Modal-module--modalcontent--290ae";